var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("그래프 관리")]),_c('p',{staticClass:"f-95 mb-5 gray-600"},[_vm._v("보고서 작성에 적용할 그래프 목록을 관리합니다.")]),_c('ChartCaseList',{attrs:{"editing_mode":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }